"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _gatsby = require("gatsby");

var _langtagUtils = require("@wapps/langtag-utils");

var _utils = require("./utils");

var Redirect =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(Redirect, _PureComponent);

  function Redirect() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Redirect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Redirect)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "perform", function () {
      var _this$props$pageConte = _this.props.pageContext,
          fallbackLng = _this$props$pageConte.fallbackLng,
          availableLngs = _this$props$pageConte.availableLngs,
          redirectPage = _this$props$pageConte.redirectPage;
      var detectedLng = window.localStorage.getItem('@igorkoLng') || (0, _langtagUtils.lookup)(availableLngs, (0, _langtagUtils.navigatorLanguages)(), fallbackLng);
      window.localStorage.setItem('@igorkoLng', detectedLng);
      var _window$location = window.location,
          hash = _window$location.hash,
          search = _window$location.search;
      var newUrl = "/".concat(detectedLng).concat(redirectPage).concat(search ? search : '').concat(hash ? hash : '');
      (0, _gatsby.navigate)(newUrl, {
        replace: true
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(Redirect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _utils.isBrowser)()) this.perform();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return Redirect;
}(_react.PureComponent);

var _default = Redirect;
exports["default"] = _default;